<template>
  <div class="container page">
    <van-nav-bar :title="$t('my.task_record')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
  
    <div class="main">
   
      <van-pull-refresh v-model="isLoading" class="records-refresh" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :error.sync="loadError"
          :loading-text="$t('common.loading')"
          :finished-text="list.length ? $t('common.no_more') : ''"
          :error-text="$t('common.load_failed_retry')"
          :immediate-check="false"
          @load="getUserGameList"
        >
        <van-empty v-if="initialized && !loading && !loadError && list.length === 0" :description="$t('withdraw.empty_data')" />
        <div class="item_list" v-for="v in localizedList" :key="v.expect">
          <div class="lottery_info">
            <van-image class="cover" :src="v.ico">
              <template v-slot:loading>
                <van-loading type="spinner"/>
              </template>
            </van-image>
            <span class="period-number">{{v.expect}}</span>
            <span class="period-number">{{v.name}}</span>
          </div>
          <div class="recent">
            <div class="kuaisan-ball left">
            <div>
              <span>{{$t("reservation.result")}}</span>
              <span class="ressquareBox">{{ v.size }}</span>
              <span class="ressquareBox">{{ v.double }}</span>
             
            </div>
          
            </div>
          </div>
          <div class="topInfo">
        
            <span v-if="v.status === 1" style="color: #07c160">{{v.status_text}}</span>
            <span v-else>{{v.status_text}}</span>
            <span>{{$t("reservation.money")}}：{{v.money}}</span>
          </div>
       <!--   <div class="topInfo">
            <span v-if="v.is_win === 1" style="color: #07c160">{{v.win_text}}</span>
            <span v-else >{{v.win_text}}</span>
            <span>金额：{{v.profit}}</span>
          </div> -->
          <!-- <div class="topInfo">
            <span>任务类型：</span>
            <span>{{v.type}}</span>
          </div> -->
          <div class="time">
            <span>{{$t("reservation.order_time")}}：{{v.create_time}}</span>
          </div>
          <div class="time">
            <span>{{$t("reservation.settle_time")}}：{{v.update_time}}</span>
          </div>
        </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      loading: true,
      finished: false,
      loadError: false,
      initialized: false,
      nextCursor: null,
      requestPending: false,
      requestVersion: 0,
      disposed: false,
      list: [],
    };
  },
  computed: {
    localizedList() {
      return this.list.map(item => {
        const opencode = item.opencode || [];
        const sum = Number(opencode[0]) + Number(opencode[1]) + Number(opencode[2]);
        const valid = Number.isFinite(sum) && sum >= 3 && sum <= 18;
        const status = Number(item.status) === 1 ? 1 : 0;
        // The API may return status labels in a different language from the UI.
        const hasSettlementTime = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(item.update_time || '');
        return {
          ...item,
          status,
          status_text: this.$t(status === 1 ? 'reservation.settled' : 'reservation.settling'),
          update_time: hasSettlementTime ? item.update_time : this.$t('reservation.awaiting_settlement'),
          size: valid ? this.$t(sum >= 11 ? 'reservation.rose' : 'reservation.lily') : '',
          double: valid ? this.$t(sum % 2 === 0 ? 'reservation.balloon' : 'reservation.fireworks') : ''
        };
      });
    }
  },
  methods: {
    back(){
      return window.history.back();
    },
    onRefresh() {
      // Responses from before a refresh must not append to the new list.
      this.requestVersion += 1;
      this.requestPending = false;
      this.nextCursor = null;
      this.list = [];
      this.finished = false;
      this.loadError = false;
      this.initialized = false;
      return this.getUserGameList();
    },
    async getUserGameList() {
      if (this.requestPending || this.finished || this.disposed) return;
      const version = this.requestVersion;
      const data = { page_size: 20 };
      if (this.nextCursor !== null) data.cursor = this.nextCursor;
      this.requestPending = true;
      this.loading = true;
      this.loadError = false;
      try {
        const res = await this.$http({
          method: 'get',
          url: 'user_get_game_list',
          data
        });
        if (this.disposed || version !== this.requestVersion) return;
        // The HTTP helper also resolves network failures as error objects.
        const page = res && res.data;
        if (!res || res.code !== 200 || !page || !Array.isArray(page.list) || typeof page.has_more !== 'boolean') {
          this.loadError = true;
          if (res && res.code === 401 && res.msg) this.$toast(res.msg);
          return;
        }
        const cursor = Number(page.next_cursor);
        if (page.has_more && (!Number.isFinite(cursor) || cursor <= 0 || (this.nextCursor !== null && cursor >= this.nextCursor))) {
          this.loadError = true;
          return;
        }
        const records = page.list.filter(item => item && item.expect != null);
        const knownPeriods = new Set(this.list.map(item => String(item.expect)));
        records.forEach(item => {
          if (!knownPeriods.has(String(item.expect))) {
            this.list.push(item);
            knownPeriods.add(String(item.expect));
          }
        });
        this.nextCursor = page.has_more ? cursor : null;
        this.finished = !page.has_more;
        this.initialized = true;
      } catch (error) {
        if (!this.disposed && version === this.requestVersion) this.loadError = true;
      } finally {
        if (!this.disposed && version === this.requestVersion) {
          this.requestPending = false;
          this.loading = false;
          this.isLoading = false;
        }
      }
    }

  },
  created() {
    if(!localStorage.getItem('token')){
      this.loading = false;
      this.finished = true;
      this.$router.push({path:'/Login'})
    }else {
      this.getUserGameList();
    }
  },
  beforeDestroy() {
    this.disposed = true;
    this.requestVersion += 1;
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
::v-deep .van-pull-refresh__track .van-pull-refresh__head *{
  color: #000000;
  font-size: 37.8px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 37.8px;
}
.container {
  overflow: hidden;
}
.container .nav-bar {
  flex-shrink: 0;
}
.container .main{
  position: relative;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  background-color: #f2f2f5;
  padding: 0 10px;
}
.records-refresh {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
::v-deep .van-pull-refresh__track {
  /* Vant's default 100% height clips long lists inside the refresh wrapper. */
  flex: 1;
  height: auto;
}
::v-deep .van-list__finished-text,
::v-deep .van-list__error-text {
  font-size: 30.24px;
  line-height: 80px;
}
.item_list{
  padding: 15px 15px;
  margin: 30px 10px;
  background: #fff;
  border-radius: 10px;
  line-height: 60px;
}

.item_list .topInfo span{
  flex: 1;
  font-size: 34.56px;
  font-weight: 700;
  color: #000;
}
.item_list .time span{
  flex: 1;
  font-size: 27px;
  font-weight: 700;
  color: #000;
}

.item_list .topInfo span:last-child{

}
.item_list .desc span{
  font-size: 27px;
  font-weight: 700;
  color: #9b9b9b;
}
.item_list .cover{
  width: 60px;
  height: 60px;
  -o-object-fit: cover;
  object-fit: cover;
}
.item_list  .period-number{
  margin-left: 50px;
  margin-right: 10px;
  height: 50px;
  line-height: 60px;
  font-size: 37.8px;
  font-weight: 700;
  color: #000;
}
.item_list .lottery_info{
  display: flex;
}
.recent {
  display: flex;
  align-items: center;
  height: 100px;
}
.kuaisan-ball .left{
  justify-content: flex-start;
}
.kuaisan-ball{
  flex: 1;
  display: flex;
  align-items: center;
}

.kuaisan-ball .res-img{
  width: 70px;
  height: 70px;
  margin-right: 30px;
}
.kuaisan-ball .res-des{
  font-weight: 700;
  text-align: center;
  color: #000;
}
.kuaisan-ball .res-des.middle{
  width: 15%;
  font-size: 37.8px;
}
.ressquareBox{
  background: linear-gradient(90deg, #f560cd, #4f2b8a);
    color: #fff;
    height: 7vw;
    line-height: 7vw;
    text-align: center;
    font-size: 3.24vw;
    font-weight: 700;
    border-radius: 16px;
    margin-left: 20px;
    padding:  13px 40px;
    min-width: 13vw;
}
</style>
